export default __webpack_public_path__ + "static/media/course2_L.3170cbba.jpg";